<div
  class="luminaire-driver luminaire-driver-regular-shadow driver"
  [attr.data-cy]="'luminaire-driver-' + driver.address"
  [ngClass]="produceClassForLuminaireDriver()"
  (click)="onClick($event)"
  [ngStyle]="produceDriverStyle(driver.x, driver.y)"
  (touchstart)="$event.stopPropagation()">
  <div>
    <svg
      tagOutline
      [isDriver]="true"
      [tags]="tags"
      class="luminaire-driver-tags"></svg>
    <div>
      <span
        class="luminaire-driver-icon or-icon or-small"
        [ngClass]="produceClassForLuminaireDriverIcon()">
      </span>
    </div>
  </div>
  <div class="luminaire-driver-properties" [ngClass]="{ 'muted': showMutedTooltip() }">
    <div class="luminaire-driver-properties-header"><h1 class="luminaire-driver-properties-id">{{getDriverIdText()}}</h1>
      <span class="luminaire-driver-properties-address">{{address16}}</span>
    </div>
    @if (tags.length) {
      <div class="luminaire-driver-properties-tags">
        @for (tag of tags; track tag.id) {
          <div class="luminaire-driver-properties-tag">
            <span class="luminaire-driver-properties-tag-color" [ngStyle]="{ 'background-color': '#' + tag.color}"></span>
            <span class="luminaire-driver-properties-tag-name">{{tag.name}}</span>
          </div>
        }
      </div>
    }
  </div>
</div>

